import { lazy } from 'react';

const ConexoesJubilutPage = lazy(() => import('../pages/ConexoesJubilut'));
const JubilutPlayerPage = lazy(() => import('../pages/JubilutPlayer'));
const JubilutMaterialPage = lazy(() => import('../pages/JubilutMaterial'));

export const ConexoesJubilutRoutes = [
  {
    path: '/conexoes-jubilut',
    element: <ConexoesJubilutPage />,
  },
  {
    path: '/conexoes-jubilut/material/:slug',
    element: <JubilutMaterialPage />,
  },
  {
    path: '/conexoes-jubilut/:slug',
    element: <JubilutPlayerPage />,
  },
];
